import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { UnifyApiInterface } from '@interface/unify-api/unify-api.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';

import { initialUnifyApiState } from './unify-api.initial-state';

export const unifyApiSlice = createSlice({
  name: 'unify',
  initialState: initialUnifyApiState,
  reducers: {
    ...baseReducerActions(initialUnifyApiState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<UnifyApiInterface>>) => {
      state.data = payload.data;
    },
  },
});

export const unifyApiActions = unifyApiSlice.actions;
